import { Box, Button, TextField, Typography } from "@mui/material";
import React, { useContext, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import LayoutAccessManagement from "components/structure/LayoutAccessManagement";
import RoleService from "services/RoleService";
import { SnackbarContext } from "context/snackBarContext";

const SRNumberInput = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const rowData = location.state?.rowData;
    const [srNumber, setSrNumber] = useState("");
    const { setOpenAlert, setSeverity, setMessage } = useContext(SnackbarContext);

    const handleSubmit = async () => {
        if (!srNumber.trim()) {
            setMessage("Please enter SR number");
            setSeverity("error");
            setOpenAlert(true);
            return;
        }
        let oldServiceNumber = rowData?.serviceNumber;
        let newServiceNumber = srNumber?.trim();
        let combinedServiceNumber = oldServiceNumber ? `${oldServiceNumber},${newServiceNumber}` : newServiceNumber;

        try {
            await RoleService.updateAssignmentStatus({
                roleId: rowData.profileId,
                assignmentStatus: "Complete",
                serviceNumber: combinedServiceNumber
            });

            setMessage("Successfully sent back to role owner");
            setSeverity("success");
            setOpenAlert(true);
            navigate("/roleCreation");
        } catch (error) {
            setMessage(error?.response?.data?.message || "Failed to update status");
            setSeverity("error");
            setOpenAlert(true);
        }
    };

    return (
        <LayoutAccessManagement>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "#f0f3f6",
                    height: "80vh",
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;",
                    borderRadius: "6px"
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 2,
                        backgroundColor: '#ffffff',
                        padding: "30px",
                        borderRadius: '12px',
                        width: '400px',
                    }}
                >
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <TextField
                            fullWidth
                            multiline
                            rows={3}
                            value={srNumber}
                            onChange={(e) => setSrNumber(e.target.value)}
                            placeholder="Service Number"
                            InputProps={{
                                endAdornment: srNumber ? null : (
                                    <span style={{
                                        color: 'red',
                                        position: 'absolute',
                                        left: '145px',
                                        top: '15px',
                                        fontSize: '16px'
                                    }}>*</span>
                                )
                            }}
                            sx={{
                                boxShadow: '0px 2px 4px 0px #ECEBEB80',
                                '& .MuiOutlinedInput-root': {
                                    '& fieldset': {
                                        borderColor: '#E0E0E0',
                                    },
                                    '&:hover fieldset': {
                                        borderColor: '#E0E0E0',
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: '#E0E0E0',
                                    },
                                },
                                '& .MuiInputBase-input': {
                                    fontFamily: 'Montserrat',
                                    fontStyle: 'italic',
                                    fontSize: '16px',
                                    fontWeight: 400,
                                    '&::placeholder': {
                                        color: '#A7A9B0',
                                        opacity: 1,
                                        fontFamily: 'Montserrat',
                                        fontStyle: 'italic',
                                        fontSize: '16px',
                                        fontWeight: 400,
                                    },
                                },
                                '& .MuiOutlinedInput-notchedOutline': {
                                    border: '1px solid #E0E0E0',
                                },
                            }}
                        />
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Button
                            onClick={handleSubmit}
                            disabled={!srNumber.trim()}
                            variant="contained"
                            sx={{
                                width: '100px',
                                height: '36px',
                                backgroundColor: '#102A62',
                                color: 'white',
                                textTransform: 'none',
                                borderRadius: '4px',
                                '&.Mui-disabled': {
                                    backgroundColor: '#6C7B8A',
                                    color: 'white',
                                    cursor: 'not-allowed',
                                },
                                '&:hover': {
                                    backgroundColor: '#102A62',
                                },
                            }}
                        >
                            OK
                        </Button>
                    </Box>
                </Box>
            </Box>
        </LayoutAccessManagement>
    );
};

export default SRNumberInput;
